module.exports = __webpack_public_path__ + "files/SPIADI2026 - BACT ADI+.3f3ad732a58972a53693322a63ccd134.xlsx";